import * as React from 'react';
import { render } from 'react-dom';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';

import './polyfill';
import { customMuiTheme } from './customMuiTheme';
import ListingIframeCalenar from './react/pages/consumer/ListingIframeCalenar';

const listingIdMatch = window.location.pathname.match(/\/embeded\/calendar\/listing\/([^/?#]+)/);
const listingId = listingIdMatch ? decodeURIComponent(listingIdMatch[1]) : undefined;
const mountNode = document.getElementById('embeded-page');

if (mountNode && listingId) {
  render(
    <StylesProvider injectFirst>
      <ThemeProvider theme={customMuiTheme}>
        <ListingIframeCalenar listingId={listingId} />
      </ThemeProvider>
    </StylesProvider>,
    mountNode,
  );
}
